import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
import Select, { StylesConfig } from 'react-select';
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import {
    getExpenseSheetByAccountEmployeeIdAsync, updateMasterExpenseSheetId, resetSelectedRecordObjectInState,
    deleteAllSelectedExpenseSheetsAsync, updateAccountEmployeeId, getDataForLockExpensePreviuosEntriesAsync,
    updateLoadClient
} from "../expenseSlice";
import ExpenseSheetItem from "./ExpenseSheetItem";
import ExpenseSearchForm from "./ExpenseSearchForm";
import ExpenseEntry from "../expenseEntries/ExpenseEntries";
import { ShowSwalWithConfirmation } from "../../../common/SweetAlert";
import { KTIcon } from "../../../_metronic/helpers";
import ExpenseSearchOffCanvas from '../../../common/OffCanvas';
import ExpenseEntryForm from "../expenseEntries/ExpenseEntryForm";
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { ShowToast } from "../../../common/Toastr";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../common/Pagination";
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import Loader from "../../../common/Loader";
import { getPageSizeArray, setItemStatus, paginationStyles, sortData, getValueFromResource } from '../../../common/timeLiveFunction';
import PageSizeSelect from '../../../common/PageSizeSelect';

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}


const ExpenseSheet = (props: any) => {
    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const location = useLocation();
    const { t } = useTranslation();
    const { expenseSheetList, isReload, selectedRecord, startDate, endDate, MasterEmployeeExpenseSheetId, isLoading, sortOrderExpenseSheet, sortColumnExpenseSheet } = useAppSelector((state) => state.expense);
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete, sessionAccountEmployeeId, maxMenuHeight } = useAppSelector((state) => state.globalState);
    const [selectedOption, setSelectedOption] = useState<{ [object: string]: any }>();
    const params = new URLSearchParams(location.search);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();
    const [showExpenseEntry, setShowExpenseEntry] = useState(false);
        const encoded = params.get("data");
        const parsedState = React.useMemo(() => {
            const encoded = params.get("data");
            return encoded ? JSON.parse(decodeURIComponent(encoded)) : {};
        }, [encoded]);
        const { widgetFilters = null, fromDashboard = false, status = null } = parsedState;
    // const { status, widgetFilters, fromDashboard } = location.state || {};
    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd === routeName);
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    useEffect(() => {
        if (isReload) {
            // const ExpenseSheetStatusId = 0;
            // const IncludeDateRange = false;
            const wf = widgetFilters || {};
            const ExpenseSheetStatusId = 0;
            // const IncludeDateRange = wf.IncludeDateRange !== undefined ? (wf.IncludeDateRange ? true : false) : false;
            const selectedYear = wf?.YearsId?.[0];
            const IncludeDateRange = selectedYear ? true : (wf.IncludeDateRange !== undefined ? wf.IncludeDateRange : false);
            let calculatedStartDate = moment(startDate);
            let calculatedEndDate = moment(endDate);
            if (selectedYear) {
                calculatedStartDate = moment(`${selectedYear}-01-01`);
                calculatedEndDate = moment(`${selectedYear}-12-31`);
            } else if (IncludeDateRange) {
                calculatedStartDate = wf?.DateRange?.startDate ? moment(wf.DateRange.startDate) : moment(startDate);
                calculatedEndDate = wf?.DateRange?.endDate ? moment(wf.DateRange.endDate) : moment(endDate);
            }
            const payload = {
                AccountEmployeeId: wf?.AccountEmployeeId?.[0] !== undefined ? wf?.AccountEmployeeId?.[0] : sessionAccountEmployeeId,
                ExpenseSheetStatusId,
                IncludeDateRange: IncludeDateRange,
                StartDate: calculatedStartDate.format('MM-DD-YYYY'),
                EndDate: calculatedEndDate.format('MM-DD-YYYY')
                //StartDate: IncludeDateRange ? (wf?.DateRange?.startDate ? moment(wf?.DateRange?.startDate).format('MM-DD-YYYY') : moment(startDate).format('MM-DD-YYYY')) : moment(startDate).format('MM-DD-YYYY'),
                //EndDate: IncludeDateRange ? (wf?.DateRange?.endDate ? moment(wf?.DateRange?.endDate).format('MM-DD-YYYY') : moment(endDate).format('MM-DD-YYYY')) : moment(endDate).format('MM-DD-YYYY')
            }
            dispatch(getExpenseSheetByAccountEmployeeIdAsync(payload));
            // dispatch(getExpenseSheetByAccountEmployeeIdAsync({
            //     AccountEmployeeId: sessionAccountEmployeeId,
            //     ExpenseSheetStatusId,
            //     IncludeDateRange,
            //     startDate: moment(startDate).format('MM-DD-YYYY'),
            //     endDate: moment(endDate).format('MM-DD-YYYY')
            // }));
        }

    }, [isReload])

    useEffect(() => {
        const wf = widgetFilters || {};
        const ExpenseSheetStatusId = 0;
        //const IncludeDateRange = wf.IncludeDateRange !== undefined ? (wf.IncludeDateRange ? true : false) : false;
        const selectedYear = wf?.YearsId?.[0];

        const IncludeDateRange = selectedYear ? true : (wf.IncludeDateRange !== undefined ? wf.IncludeDateRange : false);
        let calculatedStartDate = moment(startDate);
        let calculatedEndDate = moment(endDate);
        if (selectedYear) {
            calculatedStartDate = moment(`${selectedYear}-01-01`);
            calculatedEndDate = moment(`${selectedYear}-12-31`);
        } else if (IncludeDateRange) {
            calculatedStartDate = wf?.DateRange?.startDate ? moment(wf.DateRange.startDate) : moment(startDate);
            calculatedEndDate = wf?.DateRange?.endDate ? moment(wf.DateRange.endDate) : moment(endDate);
        }
        const payload = {
            AccountEmployeeId: sessionAccountEmployeeId,
            ExpenseSheetStatusId,
            IncludeDateRange: IncludeDateRange,
            StartDate: IncludeDateRange ? (wf?.DateRange?.startDate ? moment(wf?.DateRange?.startDate).format('MM-DD-YYYY') : moment(startDate).format('MM-DD-YYYY')) : moment(startDate).format('MM-DD-YYYY'),
            EndDate: IncludeDateRange ? (wf?.DateRange?.endDate ? moment(wf?.DateRange?.endDate).format('MM-DD-YYYY') : moment(endDate).format('MM-DD-YYYY')) : moment(endDate).format('MM-DD-YYYY')
        }

        dispatch(updateAccountEmployeeId(sessionAccountEmployeeId))
        dispatch(getExpenseSheetByAccountEmployeeIdAsync({
            AccountEmployeeId: wf?.AccountEmployeeId?.[0] !== undefined ? wf?.AccountEmployeeId?.[0] : sessionAccountEmployeeId,
            ExpenseSheetStatusId,
            IncludeDateRange: IncludeDateRange,
            StartDate: calculatedStartDate.format('MM-DD-YYYY'),
            EndDate: calculatedEndDate.format('MM-DD-YYYY')
            //StartDate: IncludeDateRange ? (wf?.DateRange?.startDate ? moment(wf?.DateRange?.startDate).format('MM-DD-YYYY') : moment(startDate).format('MM-DD-YYYY')) : moment(startDate).format('MM-DD-YYYY'),
            //EndDate: IncludeDateRange ? (wf?.DateRange?.endDate ? moment(wf?.DateRange?.endDate).format('MM-DD-YYYY') : moment(endDate).format('MM-DD-YYYY')) : moment(endDate).format('MM-DD-YYYY')
        }));

    }, [dispatch])



    const handlePageChange = (pageNumber: any) => {
        setCurrentPage(pageNumber);
    };
    const handleSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
        setCurrentPage(1);
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        setPageSize(Number(value));
        setCurrentPage(1);
    };

    const filteredData = Object.values(expenseSheetList).filter((item: any) => {
        const searchTermLowerCase = searchTerm.toLowerCase();

        return Object.values(item).some((value: any) => {
            if (typeof value === 'string') {
                return value.toLowerCase().includes(searchTermLowerCase);
            }
            return false;
        });
    });

    const indexOfLastItem = currentPage * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const currentItems = sortData(filteredData, sortOrderExpenseSheet, sortColumnExpenseSheet).slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = expenseSheetList.length;
    const recordsFiltered = filteredData.length;

    const handleOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }

    const onDeleteSelectedClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAllSelectedExpenseSheetsAsync(expenseSheetList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult[0].StatusCode === "200" ?
                                ShowToast("Expense Sheet deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult[0].ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {
                console.log("ShowSwalWithConfirmation:error ", error);
            });
    }

    const handleOnClickExpenseEntry = (selectedObject: any) => {
        let id: any = '';
        dispatch(updateMasterExpenseSheetId(id));
        const url = `/expenseentries/${'00000000-0000-0000-0000-000000000000'}`;
        navigate(url);
        dispatch(updateLoadClient(true));
    }

    const generalObject = {
        "name": getValueFromResource("Filters", dispatch, t),
        "width": "500px",
        "componentName": <ExpenseSearchForm t={t} />
    }
    return (
        <>
            {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold headerTitle"  >
                        {/* {t('Expense Sheet List')} */}
                        {getValueFromResource('Expense Sheet List', dispatch, t)}
                    </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={handleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search', dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}>
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                            {/* <Select
                                        styles={paginationStyles}
                                        maxMenuHeight={maxMenuHeight}
                                        options={getPageSizeArray()}
                                        value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                        onChange={handlePageSizeChange}
                                        className='fs-7 fw-normal'
                                     /> */}

                            <PageSizeSelect onChange={handlePageSizeChange} />

                        </div>
                        {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                    <div>
                        {(currentItems.length > 0) ? (
                            <CustomPagination
                                currentPage={currentPage}
                                onPageChange={handlePageChange}
                                pageSize={pageSize}
                                totalItems={totalItems}
                                start={(currentPage - 1) * pageSize}
                                t={t}
                            >
                            </CustomPagination>
                        ) : null}
                    </div> */}

                        {(currentItems.length > 0) && (
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    <CustomPagination
                                        currentPage={currentPage}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={(currentPage - 1) * pageSize}
                                        t={t}
                                    />
                                </div>
                            </>
                        )}

                        <div className='bullet bg-secondary h-35px w-1px mx-3' style={{ display: expenseSheetList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}></div>
                        <a id="kt_OffCanvas"
                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content=
                            // {t("Filters")}
                            {getValueFromResource('Filters', dispatch, t)}
                            data-tooltip-place="bottom">
                            <i className="bi bi-filter fs-3 iconColor"></i>
                        </a>



                        {(IsAdd || (IsDelete && expenseSheetList.some((item: any) => item.isSelected === 1))) ? (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        ) : null
                        }
                        {IsAdd &&
                            <button type="button"
                                className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                onClick={handleOnClickExpenseEntry}
                                style={{ marginRight: '2px', display: expenseSheetList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                            >
                                {/* {t('Add Expense Sheet')} */}
                                {getValueFromResource('Add Expense Sheet', dispatch, t)}
                            </button>
                        }
                        {IsDelete &&

                            <>
                                <div className="text-muted me-5" style={{ marginRight: '2px', display: expenseSheetList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                    <span className="me-2" data-kt-user-table-select="selected_count">{expenseSheetList.filter((item: any) => item.isSelected === 1).length}</span>
                                    {/* {t('Selected')} */}
                                    {getValueFromResource('Selected', dispatch, t)}
                                </div>
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                                    style={{ marginRight: '2px', display: expenseSheetList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                >
                                    <i className="bi bi-trash fs-5 me-2"></i>
                                    {/* {t('Delete')} */}
                                    {getValueFromResource('Delete', dispatch, t)}
                                </button>
                            </>
                        }
                    </div>
                </div>

                {/* <div className="card-body"> */}
                <div className="card-Report-body">
                    <div className="table-responsive">
                        <ExpenseSheetItem expenseSheetList={currentItems} modelRef={modelRef} t={t} IsEdit={IsEdit} IsDelete={IsDelete} />
                    </div>
                </div>

            </div>

            <ExpenseSearchOffCanvas obj={generalObject} />

            {/* <ExpenseEntryOffCanvas obj={generalObject1}/>  */}

        </>
    )
}
export default ExpenseSheet;